import { useAuth } from '@hb/react'
import { CHARTING_FORM_SETTINGS, ChartingFormSettings } from '@hb/shared'
import { useDocument } from '../../../../backend'

// Live subscription to the signed-in user's charting-form-settings doc (doc id = uid).
// Writers should use `set(data, true)` (merge) so unrelated settings keys are preserved.
export const useChartingFormSettings = () => {
  const { authUser } = useAuth()
  return useDocument<ChartingFormSettings>(CHARTING_FORM_SETTINGS, authUser?.uid ?? null)
}
